import React, { useContext, useEffect, useState } from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { LocaleContext } from 'routes/Router';
import mail from 'assets/images/Dashboard/mail-request.svg';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Loader from 'components/commom/Loader';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import ReusablePagination from 'components/commom/Pagination';
import CommonToast from 'components/commom/CommonToast';
import LabelWithInput from 'components/commom/LabelWithInput';
import AddIcon from 'assets/images/Dashboard/add-dashboard.svg';
import { ClearTokenRedirectLogin } from 'utils/general';
import moment from 'moment';
import SelectInputBorder from 'components/commom/SelectInputBorder';
import MoreVertOutlinedIcon from '@mui/icons-material/MoreVertOutlined';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { Box } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import CommonModal from 'components/commom/Modal';
import ReusableButton from 'components/commom/Button';
import CreateProduct from './CreateProduct';
import ImportProduct from './ImportProduct';
import { getEnterpriseProductCallAPI } from 'store/EnterpriseAdmin/Product/getEnterpriseProduct/action';
import { getAllGategoryListCallApi } from 'store/getAllCategoryList/action';
import { getSkinConcernsCallAPI } from 'store/EnterpriseAdmin/Product/getSkinConcerns/action';
import { getSkinTypesCallAPI } from 'store/EnterpriseAdmin/Product/getSkinTypes/action';

const EnterpriseProducts = () => {
  const { locale } = useContext(LocaleContext);
  const dispatch = useDispatch();
  const { showToast } = CommonToast();
  const navigate = useNavigate();
  const [count, setCount] = useState(0);
  const [page, setPage] = useState(1);
  const [formData, setFormData] = useState({
    search: '',
    tags: '',
    priority: '',
  });
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [type, setType] = useState('');
  const [loading, setLoading] = useState(true);
  const [isModalActive, setIsModalActive] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [viewData, setViewData] = useState();
  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  const itemsPerPage = 10;

  const productList = useSelector(
    (state) => state?.getEnterpriseProductReducer?.users?.data
  );
  const productLoader = useSelector(
    (state) => state?.getEnterpriseProductReducer?.loading
  );
  // const enterpriseData = useSelector(
  //   (state) => state?.getEnterpriseProfileReducer?.users?.data
  // );

  useEffect(() => {
    // getData(1, '', '', '');
    categoryData();
  }, []);

  const categoryData = () => {
    dispatch(
      getAllGategoryListCallApi({
        run: true,
        handleFunction: () => {
          concernData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const concernData = () => {
    dispatch(
      getSkinConcernsCallAPI({
        run: true,
        handleFunction: () => {
          skinData();
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const skinData = () => {
    dispatch(
      getSkinTypesCallAPI({
        run: true,
        handleFunction: () => {
          getData(1, '', '', '');
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
        },
      })
    );
  };

  const getData = (page = 1, search, tag, priority) => {
    // const body = `${formData?.search ? `?search_text=${formData?.search}` : `?page=${page}`}`;
    dispatch(
      getEnterpriseProductCallAPI('', {
        run: true,
        handleFunction: (res) => {
          setLoading(false);
          // setCount(Math.ceil(res?.count / itemsPerPage));
        },
        authorize: true,
        handleAuthorizeFunction: (res) => {
          ClearTokenRedirectLogin(navigate);
        },
        error: true,
        handleErrorFunction: (res) => {
          showToast(res?.message, 'error');
          setLoading(false);
        },
      })
    );
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChange = (e) => {
    console.log(e);
  };

  const handlePageChange = async (event, value) => {
    setPage(value);
    // getData(value, formData?.search, formData?.tags, formData?.priority);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    // getData(1, formData?.startDate, formData?.endDate);
  };

  const handleApply = () => {
    // getData(page, formData?.startDate, formData?.endDate);
  };

  const handleAction = (event, item) => {
    setAnchorEl(event.currentTarget);
    setViewData(item);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDelete = () => {
    // dispatch(
    //   deleteLeadCaptureCallAPI(viewData?.id, {
    //     run: true,
    //     handleFunction: (res) => {
    //       setIsModalActive(false);
    //       showToast(res?.message, 'success');
    //       getData(page, formData?.startDate, formData?.endDate);
    //     },
    //     authorize: true,
    //     handleAuthorizeFunction: (res) => {
    //       ClearTokenRedirectLogin(navigate);
    //     },
    //     error: true,
    //     handleErrorFunction: (res) => {
    //       showToast(res?.message, 'error');
    //     },
    //   })
    // );
  };

  return (
    <div>
      <Row className="bc-FEF9F6 m-0 p-0">
        <Col
          className={
            locale === 'en'
              ? 'commonEnContainer lg:ml-left border-l bColor-EFE3D7'
              : 'commonArContainer lg:mr-right border-l bColor-EFE3D7'
          }
        >
          <div className="d-flex justify-between">
            <h2 className="fc-292D32 fs-32 family_outfit_semiBold_600 lh-4032  m-0">
              Products
            </h2>
          </div>
          {!loading && (
            <div className="flex flex-wrap gap-x-[20px]">
              <div className="mt-[17px] w-full max-w-[180px]">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  Search:
                </div>
                <div>
                  <LabelWithInput
                    // label=""
                    placeholder="Search"
                    name="search"
                    type="text"
                    marginLabelTop={'0'}
                    marginTop={'0'}
                    bgColor="white"
                    placeholdercolor="#000000"
                    value={formData?.search}
                    onChange={(e) => handleInputChange(e)}
                  />
                </div>
              </div>
              <div className="mt-[17px] w-full max-w-[180px]">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  {'Tags'}
                </div>
                <div>
                  <SelectInputBorder
                    placeholder={'Tags'}
                    name={'tags'}
                    value={formData?.tags || ''}
                    data={[]}
                    onChange={(e) => handleChange(e)}
                    background={'#FFFFFF'}
                    colorIcon={'#292D32'}
                    placeholderColor={'#292D32'}
                  />
                </div>
              </div>
              <div className="mt-[17px] w-full max-w-[180px]">
                <div className="fc-292D32 lh-201 family_outfit_medium_500 mb-2">
                  {'Priority'}
                </div>
                <div>
                  <SelectInputBorder
                    placeholder={'Priority'}
                    name={'priority'}
                    value={formData?.priority || ''}
                    data={[]}
                    onChange={(e) => handleChange(e)}
                    background={'#FFFFFF'}
                    colorIcon={'#292D32'}
                    placeholderColor={'#292D32'}
                  />
                </div>
              </div>
              <div className="mt-[46px] w-full max-w-[180px]">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#375241] h-[48px] flex items-center justify-center text-white cursor-pointer"
                  onClick={() => {
                    handleApply();
                  }}
                >
                  Apply
                </div>
              </div>
              <div className="mt-[46px] w-full max-w-[180px]">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#375241] h-[48px] flex items-center justify-center text-white cursor-pointer"
                  onClick={() => {
                    setType('import');
                    setDrawerOpen(true);
                  }}
                >
                  Import Products
                </div>
              </div>
              <div className="mt-[46px] w-full max-w-[180px]">
                <div
                  className="fs-16 family_outfit_medium_500 lh-16 pl-04 bg-[#874529] h-[48px] flex items-center justify-center text-white cursor-pointer gap-[10px]"
                  onClick={() => {
                    setType('create');
                    setDrawerOpen(true);
                    setViewData({});
                  }}
                >
                  <Image src={AddIcon} alt={'icon'} />
                  <div>Create</div>
                </div>
              </div>
            </div>
          )}
          {productLoader || loading ? (
            <Loader />
          ) : (
            <div className="mt-[30px]">
              <Row className="listCustomHeader m-0 p-0 flex items-center">
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Product Name
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Vendor Code
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Category
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Concerns
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Skin Type
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    When to Apply
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Promo
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Priority
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Shelf
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Price
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Updated At
                  </p>
                </Col>
                <Col lg={1} md={6} sm={12}>
                  <p className="p-0 m-0 fs-14 fc-202224 family_outfit_semiBold_600 lh-176">
                    Actions
                  </p>
                </Col>
              </Row>
              <Row className="bc-FFFFFF m-0 p-0">
                {productList && productList?.length > 0 ? (
                  [...productList]
                    ?.sort((a, b) => b?.id - a?.id)
                    .map((item, index) => (
                      <Row
                        className="m-0 p-0 flex items-center listAppointment"
                        key={index}
                      >
                        <Col lg={1} md={6} sm={12}>
                          <div className="flex items-center gap-[10px]">
                            <Zoom>
                              <Image
                                src={mail}
                                alt="icon"
                                height={'34px'}
                                width={'34px'}
                                style={{ borderRadius: '4px' }}
                              />
                            </Zoom>
                            <div className="fs-14 fc-202224 family_outfit_medium_500 lh-176 flex items-center break-all">
                              {'product name'}
                            </div>
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 text-[#3C3C3C] family_outfit_regular_400 lh-176 py-[4px] px-[5px] rounded-[6px] bg-[#F5F5F5] inline-block max-w-full truncate">
                            {`${'vendor code chfg hfghg fhfgh gf hhgfh fghg'}`}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {`${'category'}`}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {`${'concerns'}`}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {`${'skin type'}`}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 uppercase">
                            {`${'AM'}`}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {`${'switcher'}`}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {'priority'}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176 py-[4px] px-[5px] rounded-[6px] bg-[#F5F5F5] inline-block max-w-full truncate">
                            {'sample dhfhsdfhsdgf'}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {'Price'}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <div className="fs-14 fc-202224 family_outfit_regular_400 lh-176">
                            {'updated at'}
                          </div>
                        </Col>
                        <Col lg={1} md={6} sm={12}>
                          <MoreVertOutlinedIcon
                            aria-describedby={id}
                            style={{ cursor: 'pointer' }}
                            onClick={(e) => handleAction(e, item)}
                          />
                        </Col>
                      </Row>
                    ))
                ) : (
                  <div className="flex flex-col justify-center items-center py-[50px]">
                    <Image
                      src={EmptyScreen}
                      alt="icon"
                      width={'301px'}
                      height={'224px'}
                    />
                    <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center	pt-30">
                      Nothing here yet
                    </div>
                  </div>
                )}
              </Row>
            </div>
          )}
          {count > 1 && (
            <Col sm={12} className="flex justify-end mt-10 p-0">
              <ReusablePagination
                count={count}
                page={page}
                showFirstButton
                showLastButton
                onChange={(event, value) => handlePageChange(event, value)}
                borderColor="#00000"
                textColor="#00000"
                selectedBgColor="#EBEBE4"
                selectedTextColor="#00000"
                selectedBorderColor="#00000"
                ellipsisBorder="none"
                borderWidth="2px"
                borderStyle="dashed"
              />
            </Col>
          )}
        </Col>
      </Row>
      <CreateProduct
        open={drawerOpen && type === 'create'}
        onClose={handleDrawerClose}
        editData={viewData}
      />
      <ImportProduct
        open={drawerOpen && type === 'import'}
        onClose={handleDrawerClose}
      />

      {/* edit and delete */}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <Box>
          <Box
            onClick={() => {
              // handleLeadEdit();
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 3,
              py: 1,
              cursor: 'pointer',
              borderBottom: '1px solid #eee',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <EditIcon fontSize="small" />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'Outfit, sans-serif',
              }}
            >
              Edit
            </Typography>
          </Box>
          <Box
            onClick={() => {
              setIsModalActive(true);
            }}
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: 1,
              px: 3,
              py: 1,
              cursor: 'pointer',
              '&:hover': {
                backgroundColor: '#f5f5f5',
              },
            }}
          >
            <DeleteIcon fontSize="small" />
            <Typography
              sx={{
                fontSize: '14px',
                fontWeight: 400,
                fontFamily: 'Outfit, sans-serif',
              }}
            >
              Delete
            </Typography>
          </Box>
        </Box>
      </Popover>
      {/* edit and delete */}

      {/* download & delete modal */}
      <CommonModal
        padding={'24px'}
        width={'500px'}
        modalActive={isModalActive}
        innerContent={
          <div>
            <Row>
              <Col xs={12}>
                <div className="">
                  <p className="p-0 m-0 fs-24 fc-292D32 family_outfit_semiBold_600">
                    Are you sure you want to delete?
                  </p>
                </div>
              </Col>
              <Col xs={12} md={12} className="mt-3 flex justify-end">
                <Stack
                  direction="horizontal"
                  gap={2}
                  className="items-center justify-end p-0"
                >
                  <ReusableButton
                    fullWidth={false}
                    variant="outlined"
                    color="#3C3C3C"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="transparent"
                    brColor="#EFE3D7"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      setIsModalActive(false);
                      handleClose();
                    }}
                  >
                    Cancel
                  </ReusableButton>

                  <ReusableButton
                    fullWidth={false}
                    variant="contained"
                    color="#F5F5F5"
                    fontSize="14px"
                    fontWeight="500"
                    padding="12px 50px"
                    height="44px"
                    bgColor="#375241"
                    brColor="#375241"
                    fontFamily="outfit_medium"
                    onClick={() => {
                      handleDelete();
                      handleClose();
                    }}
                    loading={false}
                  >
                    Delete
                  </ReusableButton>
                </Stack>
              </Col>
            </Row>
          </div>
        }
      />
      {/* download & delete modal */}
    </div>
  );
};

export default EnterpriseProducts;
